import React from "react";
import { CoObjectItem } from "../../interfaces/CoObject";
import { ObjectPanelComponent } from "../co-panel/ObjectPanelComponent";
import useObjectPanel from "./ObjectPanelHook";
import { DocumentPartMetadata } from "../../../api/models/document-part-metadata";

export interface ObjectProps {
  isEdit: boolean;
  coObject: CoObjectItem;
  documentPartMetadata: DocumentPartMetadata;
}

export const ObjectPanel: React.FunctionComponent<ObjectProps> = (props) => {
  const {
    coObject,
    documentPart,
    documentPartMetadata,
    isEdit,
    updateCoObject,
    saveCoObject,
    validator,
    originalSheetArea,
    setOriginalSheetArea,
  } = useObjectPanel(props);

  return (
    <>
      {coObject ? (
        <ObjectPanelComponent
          isEdit={isEdit}
          saveCoObject={updateCoObject}
          coObject={coObject}
          documentPart={documentPart}
          documentPartMetadata={documentPartMetadata}
          onSaveBtn={saveCoObject}
          validator={validator}
          isLocked={coObject.isLocked}
          originalSheetArea={originalSheetArea}
          setOriginalSheetArea={setOriginalSheetArea}
        />
      ) : null}
    </>
  );
};
